import React from 'react';
import HashLoader from 'react-spinners/HashLoader';

import './loader.scss';

export const Loader = () => {
  return <HashLoader color="#14b8a6" size={60} speedMultiplier={1.25} />;
};
